import { FullPageLoader } from 'components/FullPageLoader';
import { useVerificationStore } from 'views/store/useVerificationStore';
import { VerificationsTable } from './components/VerificationTable';

export const PendingVerifications = () => {
  const { loading } = useVerificationStore();

  return (
    <>
      {loading && <FullPageLoader />}

      <div className="p-4">
        <VerificationsTable />
      </div>
    </>
  );
};
